module.exports = __webpack_public_path__ + "static/media/Figure1.0f5491ad.jpg";